
const sortVariantsByAvailabilityUtil = (variants, variantReduxMap) => {
  if (!variants || !variantReduxMap) return variants

  return variants?.sort((a, b) => {
    const variantA = variantReduxMap[a.id]
    const variantB = variantReduxMap[b.id]

    if (variantA?.available && !variantB?.available) return -1
    if (!variantA?.available && variantB?.available) return 1
    return 0
  })
}

export default sortVariantsByAvailabilityUtil
